import React, { useState } from 'react'


import { makeStyles } from '@material-ui/core/styles'

import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import Divider from '@material-ui/core/Divider'

const useStyles = makeStyles(theme => ({
  
}))

const MenuButtonItems = ({
  openPage,
  anchorEl,
  items,
  onClose,
}) => {

  const [ stateItems, setStateItems ] = useState(null)

  const handleClose = () => {
    setStateItems(null)
    onClose()
  }

  const clickItem = (item) => {
    if(item.items) {
      setStateItems(item.items)
      if(item.handler) {
        item.handler()
      }
      return
    }

    if(typeof(item.handler) === 'string') {
      openPage && openPage(item.handler)
      handleClose()
    }
    else if(typeof(item.handler) === 'function') {
      item.handler()
      handleClose()
    }
    else {
      throw new Error(`unknown item handler for ${item.title}`)
    }
  }

  const getMenu = ({
    open = false,
    items,
  }) => {
    const menuItems = items.map((item, i) => {
      if(item === '-') {
        return (
          <Divider key={ i } />
        )
      }

      return (
        <MenuItem
          key={ i }
          onClick={ () => clickItem(item) }
          disabled={ item.disabled }
        >
          {
            item.icon && (
              <ListItemIcon>
                <item.icon />
              </ListItemIcon>
            )
          }
          <ListItemText 
            primary={ item.title }
          />
        </MenuItem>
      )
    })

    return (
      <Menu
        anchorEl={ anchorEl }
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={ open }
        onClose={ handleClose }
      >
        <MenuItem key="placeholder" style={{display: "none"}} />
        { menuItems }
      </Menu>
    )
  }

  const open = Boolean(anchorEl)

  return (
    <React.Fragment>
      {
        getMenu({
          open: open && !stateItems,
          items,
        })
      }
      {
        stateItems && open && (
          getMenu({
            open: true,
            items: stateItems,
          })
        )
      }
    </React.Fragment>
  )

}

export default MenuButtonItems